import { pino as createLogger } from "pino";
export { pino as createLogger } from "pino";
export const baseLoggerConfig = {
    errorKey: "error", // not err
    messageKey: "message",
    hooks: {
        /**
         * We allow support for console.log and Winston-style logger.info(message, objectContext) logging
         *
         * By default, pino only works for logger.info(objectContext, message) logging. There are subtleties here, like
         * if the call is logger.info("some %o", {foo: "bar"}), then we don't want to reverse those two arguments (it
         * would be unwanted for {foo: "bar"} to end up in the structured log; they should be formatted into the message
         * string).
         */
        logMethod(inputArgs, method, _level) {
            const [arg0, arg1, ...rest] = inputArgs;
            if (arg0 && typeof arg0 === "string" && !arg0.includes("%") && arg1 && typeof arg1 === "object") {
                // @ts-expect-error -- arg1 is the merging object, not a string, but method.apply is picking the wrong overload or something
                return method.apply(this, [arg1, arg0, ...rest]);
            }
            return method.apply(this, inputArgs);
        },
    },
};
export const silentLogger = createLogger({ ...baseLoggerConfig, level: "silent" });
/**
 * This global logger exists to help us migrate to using structured logging instead of console.log()
 *
 * One great convenience of `console` is that it is a global singleton, and that you don't need to worry about
 * passing it around. This is bad for testability, but good for ease of use. This global logger is similarly
 * very easy to access, but the downside is the application needs to replace this global singleton with a
 * properly configured logger instance, or anything using this will log incorrectly - bad formatting etc.
 *
 * Definitely try not to add additional uses of this export. You should be able to access a logger from
 * your context (e.g. dependency injection, or passed as a parameter), and optionally add bindings to it with
 * .child()
 *
 * @deprecated Get a logger from your parent context instead of using this global singleton
 */
export let globalFallbackLogger = createLogger({ level: "info" });
/**
 * Sets the global fallback logger
 * @param logger
 */
export function setGlobalFallbackLogger(logger) {
    globalFallbackLogger = logger;
}
//# sourceMappingURL=logger.js.map